import React from 'react';
import { useIntl } from 'umi';
import { useMount } from 'ahooks';
import Report from './report';
import { getReportBySystemTypeApi } from '@intelligence/services/reportService';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';
import { pageReportTypeConfig } from '@intelligence/pages/InsightsReport/_config';

const InsightsReport: React.FC = () => {
  const { formatMessage } = useIntl();

  const segmentList = [
    {
      id: 'all',
      label: formatMessage({ id: 'dbi_all' }),
      pagePoint: dbiPageLogMes.insightsReports,
    },
    // {
    //   id: 'General Gaming',
    //   label: formatMessage({ id: 'dbi_insights_report_general_game' }),
    //   pagePoint: dbiPageLogMes.insightsReportsGeneralGaming,
    // },
    // {
    //   id: 'Esports',
    //   label: formatMessage({ id: 'dbi_insights_report_esports' }),
    //   pagePoint: dbiPageLogMes.insightsReportsEsports,
    // },
    {
      id: 'Market',
      label: formatMessage({ id: 'dbi_insights_report_market' }),
      pagePoint: dbiPageLogMes.insightsReportsMarkets,
    },
    {
      id: 'Game & Genres',
      label: formatMessage({ id: 'dbi_insights_report_game_genres' }),
      pagePoint: dbiPageLogMes.insightsReportsGameGenres,
    },
    {
      id: 'Players',
      label: formatMessage({ id: 'dbi_insights_report_players' }),
      pagePoint: dbiPageLogMes.insightsReportsPlayers,
    },
    {
      id: 'Monetization',
      label: formatMessage({ id: 'dbi_insights_report_monetization' }),
      pagePoint: dbiPageLogMes.insightsReportsMonetization,
    },
    {
      id: 'Compliance',
      label: formatMessage({ id: 'dbi_insights_report_compliance' }),
      pagePoint: dbiPageLogMes.insightsReportsMonetization,
    },
  ];

  useMount(() => {
    buriedPointPage(dbiPageLogMes.insightsReports);
  });

  return (
    <Report
      reportType="insightsReports"
      searchType="insightsReportSearch"
      title={formatMessage({ id: 'dbi_insights_report' })}
      subTitle={formatMessage({ id: 'dbi_insights_report_intro' })}
      segmentList={segmentList}
      // 接口
      // getReportFun={getInsightsReportListApi}
      getReportFun={() => getReportBySystemTypeApi('intelligence_insights')}
      pageLogMes={dbiPageLogMes.insightsReports}
      reportTypeConfig={pageReportTypeConfig.insightsReports}
    />
  );
};

export default InsightsReport;
